module.exports = __webpack_public_path__ + "img/download_play.a40b345f.png";